import classNames from '@ui-components-3/ui/lib/utils/classNames'
import type { ComponentPropsWithoutRef } from 'react'
import type { Merge } from '@ui-components-3/ui/lib/types'

type ErrorFieldFormProps = Merge<
  ComponentPropsWithoutRef<'p'>,
  {
    className?: string
  }
>

const ErrorFieldForm = ({ className, ...props }: ErrorFieldFormProps) => (
  <p className={classNames('leading-4 text-fuchsia-800 text-xs mt-1', className)} {...props} />
)

export default ErrorFieldForm
